var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.1743 8.12177L17.731 0.5H16.1773L10.4841 7.11788L5.93696 0.5H0.692383L7.56853 10.5074L0.692383 18.5H2.2462L8.25835 11.5113L13.0605 18.5H18.305L11.1739 8.12177H11.1743ZM9.04613 10.5956L8.34944 9.59906L2.80606 1.66971H5.19263L9.6662 8.06895L10.3629 9.06546L16.178 17.3835H13.7914L9.04613 10.596V10.5956Z",
  fill: "black"
})));
export default SvgIconTwitter;